document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('[data-slider]');

  sliders.forEach(sliderContainer => {
    const track = sliderContainer.querySelector('.slider-track');
    const originalSlides = Array.from(sliderContainer.querySelectorAll('.slider-slide'));
    const dots = sliderContainer.querySelectorAll('[data-slider-dot]');
    const transitionDuration = parseInt(sliderContainer.getAttribute('data-transition-duration')) || 5000;
    const animationSpeed = 500; // Vitesse fixe de l'animation de glissement

    // Respect reduced motion: stop looping videos
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sliderContainer.querySelectorAll('video').forEach(video => {
        video.removeAttribute('autoplay');
        video.pause();
      });
    }

    if (originalSlides.length <= 1) return;

    // Clone first slide and append to end for infinite loop effect
    const firstSlideClone = originalSlides[0].cloneNode(true);
    track.appendChild(firstSlideClone);

    const allSlides = Array.from(track.querySelectorAll('.slider-slide'));
    let currentIndex = 0;
    let autoplayInterval;
    let isTransitioning = false;

    // Drag state
    const wrapper = sliderContainer.querySelector('.slider-wrapper');
    let isDragging = false;
    let dragStartX = 0;
    let dragCurrentX = 0;
    let dragStartTranslate = 0;
    let hasDragged = false;

    function getSliderWidth() {
      return wrapper.offsetWidth;
    }

    function getPointerX(e) {
      return e.touches ? e.touches[0].clientX : e.clientX;
    }

    function goToSlide(index, instant = false) {
      if (isTransitioning) return;

      isTransitioning = true;
      currentIndex = index;

      // Disable transition for instant moves
      if (instant) {
        track.style.transition = 'none';
      } else {
        track.style.transition = `transform ${animationSpeed}ms cubic-bezier(0.4, 0, 0.2, 1)`;
      }

      track.style.transform = `translateX(-${currentIndex * 100}%)`;

      // Update dots (use modulo to handle clone)
      const dotIndex = currentIndex % originalSlides.length;
      dots.forEach((dot, i) => {
        dot.classList.toggle('slider-dot--active', i === dotIndex);
      });

      setTimeout(() => {
        isTransitioning = false;

        // If we're on the cloned slide, instantly jump back to first slide
        if (currentIndex === originalSlides.length) {
          goToSlide(0, true);
        }
      }, instant ? 0 : animationSpeed);
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function startAutoplay() {
      clearInterval(autoplayInterval);
      autoplayInterval = setInterval(nextSlide, transitionDuration);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    // Dot click handlers
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goToSlide(index);
        stopAutoplay();
        startAutoplay();
      });
    });

    // Pause on hover (only when not dragging — mouseleave during drag is handled by dragEnd)
    sliderContainer.addEventListener('mouseenter', stopAutoplay);
    sliderContainer.addEventListener('mouseleave', function() {
      if (!isDragging) startAutoplay();
    });

    // --- Drag / Swipe ---
    function dragStart(e) {
      if (isTransitioning) return;
      // Don't hijack clicks on dots or on the slide CTA button
      if (e.target.closest('[data-slider-dot]')) return;
      if (e.target.closest('.slider-slide__button-wrap')) return;

      isDragging = true;
      hasDragged = false;
      dragStartX = getPointerX(e);
      dragCurrentX = dragStartX;
      dragStartTranslate = -(currentIndex * getSliderWidth());

      track.style.transition = 'none';
      stopAutoplay();
      wrapper.classList.add('is-dragging');

      // Prevent default only for mouse to avoid text selection; let touch scroll naturally until we decide
      if (!e.touches) e.preventDefault();
    }

    function dragMove(e) {
      if (!isDragging) return;

      dragCurrentX = getPointerX(e);
      const delta = dragCurrentX - dragStartX;

      if (Math.abs(delta) > 10) hasDragged = true;

      // For touch: prevent default only when dragging horizontally to avoid blocking vertical scroll
      if (e.cancelable && e.touches && Math.abs(delta) > 10) {
        e.preventDefault();
      }

      track.style.transform = `translateX(${dragStartTranslate + delta}px)`;
    }

    function dragEnd(e) {
      if (!isDragging) return;
      isDragging = false;
      wrapper.classList.remove('is-dragging');

      const delta = dragCurrentX - dragStartX;
      const slideWidth = getSliderWidth();
      const threshold = slideWidth * 0.2;

      let targetIndex = currentIndex;
      if (delta < -threshold) {
        targetIndex = currentIndex + 1; // swipe left → next
      } else if (delta > threshold) {
        targetIndex = currentIndex - 1; // swipe right → prev
      }

      // Clamp: allow going to clone (originalSlides.length) but not beyond, and not below 0
      targetIndex = Math.max(0, Math.min(targetIndex, originalSlides.length));

      goToSlide(targetIndex);
      startAutoplay();
    }

    // Prevent click from firing after a drag
    wrapper.addEventListener('click', function(e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);

    // Mouse events
    wrapper.addEventListener('mousedown', dragStart);
    wrapper.addEventListener('mousemove', dragMove);
    wrapper.addEventListener('mouseup', dragEnd);
    wrapper.addEventListener('mouseleave', dragEnd);

    // Touch events
    wrapper.addEventListener('touchstart', dragStart, { passive: true });
    wrapper.addEventListener('touchmove', dragMove, { passive: false });
    wrapper.addEventListener('touchend', dragEnd);

    // Start autoplay
    startAutoplay();
  });
});
